import {
  regexErrors,
  regexes,
  regexPlaceholders,
  tindakLanjutPenangananOptions,
} from "./helper.js";
export let data = {
  title: "Rawat Jalan Baru",
  backBtn: "/ralan",
  actionBtn: [
    {
      class: "btn-secondary  btn-with-icon-left",
      label: "Cetak Kartu Pasien",
      link: "",
      target: "_blank",
      iconLeft: "print",
    },
  ],
  breadcrumb: [
    { title: "Rawat Jalan", link: "/ralan" },
    { title: "Baru", active: true },
  ],
};
export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" },
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)",
        },
        {
          colnum: 7,
          icon: "",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)",
        },
      ],
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 \nPerumnas Depok I Kel. Depok Jaya, \nKec. Pancoran Mas Depok, Jawa Barat",
        },
      ],
    },
  ],
};
export let asuransiArray = [
  { value: 1, label: "Prudential" },
  { value: 2, label: "BNI Life Insurance" },
  { value: 3, label: "AXA Mandiri Insurance" },
];
export let today = new Date();
import { getTime } from "./helper.js";
export let time = getTime(today.getHours(), today.getMinutes());
export let leftForm = [
  {
    colnum: 2,
    columns: [
      {
        label: "No Registrasi",
        type: "text",
        placeholder: "",
        name: "no_reg",
        value: "",
        readonly: true,
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
      {
        label: "No Rawat",
        type: "text",
        placeholder: "",
        readonly: true,
        name: "no_rawat",
        value: "",
        mandatory: true,
        additional: "",
        colwidth: "8",
      },
    ],
  },
  {
    colnum: 2,
    columns: [
      {
        label: "Tanggal Periksa",
        type: "date",
        placeholder: "Pilih tanggal periksa",
        name: "tgl_periksa",
        value: today,
        // readonly:true,
        mandatory: true,
        additional: "",
        colwidth: "6",
      },
      {
        label: "Jam",
        type: "time",
        placeholder: "",
        name: "jam_periksa",
        // readonly:true,
        value: time,
        mandatory: true,
        additional: "",
        colwidth: "4",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Jenis Periksa",
        type: "radio",
        placeholder: "",
        name: "jen_periksa",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "Kunjungan Pasien",
            value: "Kunjungan Pasien",
          },
          {
            label: "Kontrol Lanjutan",
            value: "Kontrol Lanjutan",
          },
          {
            label: "Post Operasi",
            value: "Post Operasi",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Unit",
        type: "select",
        placeholder: "Pilih Unit",
        name: "id_unit",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "Memuat data unit..",
            value: "null",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Dokter yang Dituju",
        type: "select",
        placeholder: "Pilih Dokter",
        name: "id_dokter",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "Pilih Unit Terlebih Dahulu",
            value: "null",
          },
        ],
        additional: "",
      },
    ],
  },
];
export let paymentForm = [
  {
    colnum: 1,
    columns: [
      {
        label: "Metode Pembayaran",
        type: "radio",
        placeholder: "",
        name: "id_asuransi",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "Umum",
            value: "1",
          },
          {
            label: "BPJS",
            value: "2",
          },
          {
            label: "Asuransi Lainnya",
            value: "3",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        name: "asuransi_lain",
        type: "hidden",
        label: "Pilih Asuransi",
        options: asuransiArray,
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Nomor Peserta",
        type: "text",
        placeholder: "Masukkan nomor peserta",
        name: "no_peserta",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "",
            value: "",
          },
        ],
        additional: "",
      },
    ],
  },
];
export let referenceForm = [
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "radio",
        placeholder: "",
        name: "dirujuk",
        value: "0",
        optional: true,
        multiple: false,
        options: [
          {
            label: "Tanpa Rujukan",
            value: "0",
          },
          {
            label: "Dengan Rujukan",
            value: "1",
          },
        ],
        additional: "",
      },
    ],
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Asal Rujukan",
        type: "hidden",
        placeholder: "Pilih asal rujukan",
        name: "asal_rujukan",
        value: "",
        mandatory: true,
        additional: "",
        action: "/#/master/faskes/form",
        actionText: "Tambah Faskes Baru",
        actionIcon: "add",
        refresh: () => {},
        options: [],
      },
    ],
  },
  // {
  //   colnum: 1,
  //   columns: [
  //     {
  //       label: "Tindak Lanjut Penanganan",
  //       type: "radio",
  //       placeholder: "",
  //       name: "tindak_lanjut_pelayanan",
  //       value: "Dirawat",
  //       optional:true,
  //       multiple: false,
  //       options: tindakLanjutPenangananOptions,
  //       additional: ""
  //     }
  //   ]
  // },
  {
    colnum: 1,
    columns: [
      {
        label: "Tujuan Rujukan",
        type: "hidden",
        placeholder: "Pilih tujuan rujukan",
        name: "tujuan_rujukan",
        value: "",
        mandatory: true,
        additional: "",
        action: "/#/master/faskes/form",
        actionText: "Tambah Faskes Baru",
        actionIcon: "add",
        refresh: () => {},
        options: [],
      },
    ],
  },
];
